import React from 'react';
import { IconNotification, IconSearch } from '../Icons';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';

import PropTypes from 'prop-types';
export default function Navbar({ title }) {
  return (
    <div className="flex items-center justify-end h-20 w-full right-0 bg-white/50  border-b  border-red-100">
      <Link
        to={'/'}
        className="flex items-center  justify-end w-full px-3 border-b  border-slate-100 h-20 bg-white">
        <div className="flex items-center">
          <h1 className="text-xs uppercase font-bold text-red-500 mx-1">FTTH</h1>
          <h1 className="text-sm  font-bold leading-normal text-gray-600 uppercase">Supercell</h1>
        </div>
        <div className={'w-16 h-20 flex items-center justify-center'}>
          <img src={logo} alt="" />
        </div>
      </Link>
      <div className={'mr-auto'}></div>
    </div>
  );
}
Navbar.propTypes = {
  title: PropTypes.string,
  Icon: PropTypes.any
};
